import React from "react";
import { Box, Typography } from "@mui/material";
import { Colors } from "../../../../theme/colors";
import { CurrencyInput } from "../JobDescriptionForm/CurrencyInput";

interface JobPayRangeProps {
  fromValue: string | null;
  toValue: string | null;
  setFromValue?: (val: string) => void;
  setToValue?: (val: string) => void;
  isDiabled?: boolean
}

const JobPayRange: React.FC<JobPayRangeProps> = ({
  fromValue,
  toValue,
  setFromValue,
  setToValue,
  isDiabled = false
}) => {
  return (
    <Box
      sx={{
        marginTop: "20px",
        borderRadius: "6px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flexWrap: "wrap",
        marginBottom: "20px",
      }}
    >
      <Typography color={Colors.black} fontSize={"14px"} variant="h6">
        Job Pay Range
      </Typography>

      {!isDiabled && <Typography
        sx={{
          width: "100%",
          fontWeight: 400,
          fontSize: "12px",
          color: "#9D9D9D",
        }}
        variant="h6"
      >
        Enter range to offer candidates. If pay is an exact amount, enter the
        same in both fields.
      </Typography>}

      <Box sx={{ display: "flex", width: "100%", gap: "15px" }}>
        {/* From */}
        <Box sx={{ width: "50%" }}>
          <Typography
            sx={{
              fontWeight: 500,
              fontSize: "12px",
              lineHeight: "18px",
              color: "#464646",
              paddingBottom: "5px",
              paddingTop: "10px",
            }}
          >
            From
          </Typography>
          <CurrencyInput
            value={fromValue}
            onChange={(val) => setFromValue(val || "")}
            placeholder="Enter minimum pay"
            border={`1px solid ${Colors.grey_border}`}
            isDiabled={isDiabled}
          />
        </Box>

        {/* To */}
        <Box sx={{ width: "50%" }}>
          <Typography
            sx={{
              fontWeight: 500,
              fontSize: "12px",
              lineHeight: "18px",
              color: "#464646",
              paddingBottom: "5px",
              paddingTop: "10px",
            }}
          >
            To
          </Typography>
          <CurrencyInput
            value={toValue}
            onChange={(val) => setToValue(val || "")}
            placeholder="Enter maximum pay"
            border={`1px solid ${Colors.grey_border}`}
            isDiabled={isDiabled}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default JobPayRange;
